import { render, staticRenderFns } from "./AddOrderReturn.vue?vue&type=template&id=3213f01a&"
import script from "./AddOrderReturn.vue?vue&type=script&lang=js&"
export * from "./AddOrderReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports